import { LitElement, html, css } from 'lit';

class LoadingLogo extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1000;
      }

      .loader-wrapper {
        position: relative;
        width: 96px;
        height: 96px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* Anillo exterior con gradiente que gira */
      .ring-outer {
        position: absolute;
        inset: -8px;
        border-radius: 50%;
        background: conic-gradient(
          from 0deg,
          transparent 0deg,
          rgba(14, 165, 233, 0.3) 60deg,
          rgba(14, 165, 233, 0.9) 120deg,
          rgba(245, 158, 11, 0.5) 180deg,
          rgba(14, 165, 233, 0.3) 240deg,
          transparent 300deg
        );
        animation: ringSpin 1.8s linear infinite;
      }

      .ring-outer::after {
        content: '';
        position: absolute;
        inset: 4px;
        background: transparent;
        border-radius: 50%;
        z-index: 0;
      }

      /* Anillo interior - sentido contrario */
      .ring-inner {
        position: absolute;
        inset: 4px;
        border-radius: 50%;
        border: 2px solid transparent;
        border-top-color: rgba(14, 165, 233, 0.8);
        border-right-color: rgba(245, 158, 11, 0.4);
        animation: ringSpin 2.2s linear infinite reverse;
        z-index: 1;
      }

      .logo-core {
        position: relative;
        z-index: 2;
        width: 68px;
        height: 68px;
        overflow: visible;
        border-radius: 0;
        background: transparent;
      }

      .logo-core img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
        filter: drop-shadow(0 2px 6px rgba(14, 165, 233, 0.35));
        image-rendering: auto;
        -webkit-font-smoothing: antialiased;
      }

      :host-context([dark-mode]) .logo-core img {
        filter: drop-shadow(0 2px 10px rgba(14, 165, 233, 0.5));
      }

      /* Glow pulsante */
      .glow {
        position: absolute;
        inset: -20px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(14, 165, 233, 0.2) 0%, transparent 70%);
        animation: glowPulse 2s ease-in-out infinite;
        pointer-events: none;
      }

      @keyframes ringSpin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      @keyframes glowPulse {
        0%, 100% { opacity: 0.6; transform: scale(1); }
        50% { opacity: 1; transform: scale(1.2); }
      }

    `;
  }

  render() {
    return html`
      <div class="loader-wrapper">
        <div class="glow"></div>
        <div class="ring-outer"></div>
        <div class="ring-inner"></div>
        <div class="logo-core">
          <picture>
            <source
              type="image/webp"
              srcset="/images/icon-2026-3d.webp, /images/icon-2026-3d@2x.webp 2x"
            >
            <img
              src="/images/icon-2026-3d.png"
              srcset="/images/icon-2026-3d@2x.png 2x"
              width="68"
              height="68"
              alt="TRAZiT"
              loading="eager"
              fetchpriority="high"
            >
          </picture>
        </div>
      </div>
    `;
  }
}

customElements.define('loading-logo', LoadingLogo);
